/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Color_BlueInputs */

const en_booking_color_blue = /** @type {(inputs: Booking_Color_BlueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blue`)
};

const pl_booking_color_blue = /** @type {(inputs: Booking_Color_BlueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niebieski`)
};

/**
* | output |
* | --- |
* | "Blue" |
*
* @param {Booking_Color_BlueInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_color_blue = /** @type {((inputs?: Booking_Color_BlueInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Color_BlueInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_color_blue(inputs)
	return en_booking_color_blue(inputs)
});